import { icons } from 'assets';
import Button from 'Components/shared/button';
import React from 'react'

const Back = ({ onClick, style,...props }) => {
    return (
        <Button variant="empty" color="secondary" className="adjust"
         onClick={onClick} style={{minWidth:"0", flexGrow:0, ...style }} {...props}>
            <img src={icons.back_arrow} alt="go back"  /> 
            <span style={{paddingLeft:"10px"}}>Back</span>
        </Button>   
    )
}

export default Back;